import { render } from "./AssetTypeDetails.vue?vue&type=template&id=1f113508"
import script from "./AssetTypeDetails.vue?vue&type=script&lang=js"
export * from "./AssetTypeDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/playbooks/admin/AssetTypeDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f113508"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f113508', __exports__)) {
    api.reload('1f113508', __exports__)
  }
  
  module.hot.accept("./AssetTypeDetails.vue?vue&type=template&id=1f113508", () => {
    api.rerender('1f113508', render)
  })

}


export default __exports__